import React from 'react';
import { useSelector } from 'react-redux';
import UsersLabsForm from '../../../components/UsersLabsForm/UsersLabsForm';
import "./style.scss";

function AddLab() {
  const user = useSelector((state) => state.auth?.user?.data);

  if (user?.role_id !== 1) {
    return "Your are not authorized to view this page";
  }
    
  return (
    <div>
        <UsersLabsForm userslab={null} />
    </div>
  );
}

export default AddLab
